export default {
  rushOrder: 'rush-order',
  shiphero: 'shiphero',
};
